import React, { useState } from "react";
import { toast } from "sonner";
import { Mail, MapPin, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = (e) => {
    e.preventDefault();
    toast.success("Merci ! Votre message a bien été envoyé.");
    setForm({ name: "", email: "", message: "" });
  };

  return (
    <div className="max-w-5xl mx-auto px-6 lg:px-12 py-16">
      <div className="text-center mb-14">
        <p className="text-[#C9A24B] text-xs tracking-[0.3em] uppercase mb-3">Parlons de votre événement</p>
        <h1 className="font-serif text-4xl sm:text-5xl text-white">Contactez-nous</h1>
      </div>

      <div className="grid md:grid-cols-2 gap-12">
        <div className="space-y-6">
          {[
            { icon: Mail, label: "Email", value: "contact@myse.com" },
            { icon: Phone, label: "Téléphone", value: "+33 1 00 00 00 00" },
            { icon: MapPin, label: "Bureau", value: "Paris · Dubaï · New York" },
          ].map((c) => (
            <div key={c.label} className="flex items-center gap-4">
              <div className="w-12 h-12 rounded-full gold-border flex items-center justify-center text-[#C9A24B]">
                <c.icon size={20} />
              </div>
              <div>
                <div className="text-xs uppercase tracking-wider text-[#A19E95]">{c.label}</div>
                <div className="text-white">{c.value}</div>
              </div>
            </div>
          ))}
          <p className="font-script text-4xl gold-text pt-6">Good People, Great Moments</p>
        </div>

        <form onSubmit={submit} className="space-y-4 p-6 rounded-2xl border border-white/10 glass">
          <div>
            <Label className="text-white mb-2 block">Nom</Label>
            <Input data-testid="contact-name" value={form.name} onChange={(e) => set("name", e.target.value)} required className="bg-[#181820] border-white/10 text-white" />
          </div>
          <div>
            <Label className="text-white mb-2 block">Email</Label>
            <Input type="email" data-testid="contact-email" value={form.email} onChange={(e) => set("email", e.target.value)} required className="bg-[#181820] border-white/10 text-white" />
          </div>
          <div>
            <Label className="text-white mb-2 block">Message</Label>
            <Textarea data-testid="contact-message" value={form.message} onChange={(e) => set("message", e.target.value)} rows={4} required className="bg-[#181820] border-white/10 text-white" />
          </div>
          <Button type="submit" data-testid="contact-submit-btn" className="w-full gold-bg text-black font-semibold rounded-full py-6 hover:opacity-90">
            Envoyer le message
          </Button>
        </form>
      </div>
    </div>
  );
}
